export default {
  baseUrl: "https://api.theincircle.com/api/employer",
  // baseUrl: 'http://localhost:3900/api/employer',
  employeeProfile: "",
  adminUri: "/admin",
  apiEndpointUri: "",
  employerLogin: "/login",
  employerRegister: "/register",
  otpLoginVerify: "/login/verify-otp",
  searchCities: "/search-locations",
  searchSkill: "/search-skills",
  suggestedSkill: "/skill-suggestions",
  searchLocalities: "/fetch-localities",
  industrailArea: "/industrial-area-list",
  // numOfApplicationsList: '/get-job-application-new',
  numOfApplicationsList: "/get-no-of-applications",
  paidPerk: "/paid-perks",
  fetchIndustries: "/fetch-industries",
  fetchEducations: "/fetch-qualification",
  premiumPlan: "/search-plans?planType=JobPosting",
  databasePlan: "/search-plans?planType=Database",
  pendingJobPostLink: "/add-pending-job",
  postedJobLink: "/posted-job",
  updatePendingJobPostLink: "/update-pending-job",
  employerProfile: "/employer-profile",
  submitPostJob: "/post-a-job",
  postedJobList: "/my-posted-jobs",
  viewJob: "/view-job",
  updateJob: "/update-job",
  contactus: "/contact-us",
  salesEnquiry: "/sales-enquiry-form",
  updateEmployerProfile: "/update-employer-profile",
  getMatchingResume: "/get-matching-resume",
  getExactMatchingResume: "/get-exact-matching-resume",
  getAllPlan: "/search-plans",
  getOrderId: "/add-to-cart ",
  fetchOrderDetails: "/order-details",
  getJobApplications: "/get-job-application-new",
  dashboard: "/dashboard",
  settings: "/settings",
  planDetails: "/get-plan-details",
  addJobFeedback: "/add-job-feedback",
  getFeedbackList: "/job-list-with-feedback",
  getBillNumber: "/get-bill-number",
  verifyGst: "/verify-and-update-gst",
  uploadGst: "/upload-gst-doc",
  uploadInvoice: "/upload-invoice",

  // NEW BACKEND API 2023 END

  searchOffshoreCities: "/search-offshore-locations",
  fetchIndustriesList: "/get-all-industries-by-lang",
  otpRegistrationVerify: "/register-otp-verify",
  specialPlan: "/get-special-offer",
  functionalAreas: "/fetch-functional-area",
  employerSubscription: "/my-subscriptons",
  // submitPostJob: "/post-a-new-job-before-login",
  submitOffshorePostJob: "/post-offshore-job",
  submitPostContractJob: "/post-contract-job",
  veriyfyPostJob: "/verify-post-job",
  // numOfApplicationsList: "/get-no-of-applications",
  postedContractJobList: "/my-contract-jobs",
  updateExistingOrder: "/update-existing-orders",
  unpaidJobList: "/my-unpaid-posted-jobs",
  getContractJobApplications: "/get-contract-job-applications",

  fetchContractJobDetails: "/view-job",
  activateToPaid: "/activate-to-paid",
  pinToTop: "/pin-to-top",
  updateOrder: "/update-order",
  footer: "/footer",
  hideShowPlanAfterLogin: "/check-plan-after-login",
  resendOtp: "/resend-otp",
  checkViewJobApp: "/check-free-profile",
  convertToPaidLogin: "/convert-to-paid-login",
  allFeedbackList: "/all-feedback",
  addUserFeedback: "/add-user-feedback",
  downloadExcel: "/download-excel",
  industryProfile: "/industry-profile-new",
  // skillSuggestion: "/skill-suggestions",
  // New Employer constant
  checkResumeEmployee: "/check-resume",
  findResumeMatching: "/get-matching-resume-counts", //"/matching-resume"
  savedResume: "/get-saved-resume",
  // viewEmployerProfile: "",

  // employee routes
  employeeSendOtp: "/auth/send-otp",
  employeeOtpLoginVerify: "/auth/verify-otp",
  employeeRegister: "/user/create-profile",
  // findResumeData: "/resume-search",
  findResumeData: "/find-resume",
  fetchAllSkills: "/all-skills",
  downloadResumeExcel: "/download-excel",
  // fetchAllLocations: "/all-job-city",
  fetchAllLocations: "/job-top-city",
  // employeeRegister: "/employee/register",
  getJobFeedbackStatus: "/get-feedback-status",

  getListOfHireEmployee: "/listhireemployee",
  shortlistJob: "/shortlistJob",
  removejob: "/remove-employee",
};

// https://www.theincircle.com/node/search-locations?location=ma&fromAlias=null
